import { css } from '@emotion/react'
import { TipoVisualizacaoBuscaAtivaVacinacaoEnum } from 'graphql/types.generated'
import { isNumber } from 'lodash'
import { AcompanhamentoExpandableFilterContainer } from 'view/acompanhamento/components/AcompanhamentoExpandableFilterContainer'
import { LinkVerEquipesVinculadasView } from 'view/vinculacao-equipes/LinkVerEquipesVinculadasView'

import { AcompanhamentoFilterItem } from '../../../acompanhamento/components/AcompanhamentoFilterItem'
import { BuscaAtivaVacinacaoFormModel, tipoVisualizacaoRecord } from '../model-buscaAtivaVacinacao'
import { faixaEtariaFormatter } from '../utils-buscaAtivaVacinacao'

export interface BuscaAtivaVacinacaoActiveFiltersProps {
  filters: BuscaAtivaVacinacaoFormModel
}

export default function BuscaAtivaVacinacaoActiveFilters({ filters }: BuscaAtivaVacinacaoActiveFiltersProps) {
  const { grupoAlvo, status, equipe, microareas, faixaEtaria, filtrosAvancados, tipoVisualizacao } = filters

  return (
    <AcompanhamentoExpandableFilterContainer
      resetDependency={filters}
      footer={<LinkVerEquipesVinculadasView equipe={equipe} />}
    >
      {tipoVisualizacao && (
        <AcompanhamentoFilterItem
          label={`Vacinas d${
            tipoVisualizacao === TipoVisualizacaoBuscaAtivaVacinacaoEnum.CALENDARIO_VACINAL ? 'o' : 'a'
          }`}
          value={`${tipoVisualizacaoRecord[tipoVisualizacao].toLowerCase()}`}
          textStyle={css`
            font-weight: bold;
          `}
        />
      )}
      {microareas && <AcompanhamentoFilterItem label='Microáreas:' value={microareas.join(', ')} />}
      {grupoAlvo && <AcompanhamentoFilterItem label='Grupo-alvo:' value={grupoAlvo.descricao} />}
      {isNumber(faixaEtaria.firstValue || faixaEtaria.secondValue) && (
        <AcompanhamentoFilterItem label='Faixa etária:' value={faixaEtariaFormatter(faixaEtaria)} />
      )}
      {status && <AcompanhamentoFilterItem label='Status da vacina:' value={status.descricao} />}
      {filtrosAvancados?.imunobiologicos?.isNotEmpty() && (
        <AcompanhamentoFilterItem
          label='Imunobiológico:'
          value={filtrosAvancados.imunobiologicos.map((imuno) => imuno.sigla).join(', ')}
        />
      )}
      {filtrosAvancados?.doses?.isNotEmpty() && (
        <AcompanhamentoFilterItem label='Dose:' value={filtrosAvancados.doses.map((dose) => dose.sigla).join(', ')} />
      )}
      {filtrosAvancados?.gruposAtendimento?.isNotEmpty() && (
        <AcompanhamentoFilterItem
          label='Grupo de atendimento:'
          value={filtrosAvancados.gruposAtendimento.map((grupo) => grupo.nome.capitalize()).join(', ')}
        />
      )}
      {filtrosAvancados?.tipoLogradouro && (
        <AcompanhamentoFilterItem
          label='Tipo de logradouro:'
          value={filtrosAvancados.tipoLogradouro.nome.capitalize()}
        />
      )}
      {filtrosAvancados?.logradouro && (
        <AcompanhamentoFilterItem label='Logradouro:' value={filtrosAvancados.logradouro.trim().capitalize()} />
      )}
      {filtrosAvancados?.bairro && (
        <AcompanhamentoFilterItem label='Bairro:' value={filtrosAvancados.bairro.trim().capitalize()} />
      )}
    </AcompanhamentoExpandableFilterContainer>
  )
}
